import script from "./EditorTexto.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorTexto.vue?vue&type=script&setup=true&lang=js"

import "./EditorTexto.vue?vue&type=style&index=0&id=7959b6cc&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7959b6cc"]])

export default __exports__